import { render, staticRenderFns } from "./ElHeadlineV2.vue?vue&type=template&id=eff18e26"
import script from "./ElHeadlineV2.vue?vue&type=script&lang=js"
export * from "./ElHeadlineV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports